

import Vue from 'vue'
import Component from "vue-class-component";
import CourierList from "@/components/courier/CourierList.vue";
import CourierCatalogByCountry from "@/components/courier/CourierCatalogByCountry.vue";

@Component({
  components: {
    CourierCatalogByCountry,
    CourierList,
  }
})
export default class Couriers extends Vue {
  protected tab: number = 0;
}

